export default [
  {
    path: "/info/preciousmetaltype",
    name: "preciousmetaltype",
    component: () => import("@/views/info/preciousmetaltype/index.vue"),
    meta: {
      pageTitle: "PreciousMetalType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetaltype/edit/id=:id",
    name: "EditPreciousMetalType",
    component: () => import("@/views/info/preciousmetaltype/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalType",
      navActiveLink: "preciousmetaltype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetalsettlementaccountsetting",
    name: "preciousmetalsettlementaccountsetting",
    component: () => import("@/views/info/preciousmetalsettlementaccountsetting/index.vue"),
    meta: {
      pageTitle: "PreciousMetalSettlementAccountSetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalSettlementAccountSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetalsettlementaccountsetting/edit/id=:id",
    name: "EditPreciousMetalSettlementAccountSetting",
    component: () => import("@/views/info/preciousmetalsettlementaccountsetting/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalSettlementAccountSetting",
      navActiveLink: "preciousmetalsettlementaccountsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalSettlementAccountSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetalsettlementaccountsetting/view/id=:id",
    name: "ViewPreciousMetalSettlementAccountSetting",
    component: () => import("@/views/info/preciousmetalsettlementaccountsetting/view.vue"),
    meta: {
      pageTitle: "PreciousMetalSettlementAccountSetting",
      navActiveLink: "preciousmetalsettlementaccountsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalSettlementAccountSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetalsettlementaccountconfig",
    name: "preciousmetalsettlementaccountconfig",
    component: () => import("@/views/info/preciousmetalsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "PreciousMetalSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetalsettlementaccountconfig/edit/id=:id",
    name: "EditPreciousMetalSettlementAccountConfig",
    component: () => import("@/views/info/preciousmetalsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalSettlementAccountConfig",
      navActiveLink: "preciousmetalsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicpreciousmetalallowtransactionconfig",
    name: "republicpreciousmetalallowtransactionconfig",
    component: () => import("@/views/info/republicpreciousmetalallowtransactionconfig/index.vue"),
    meta: {
      pageTitle: "RepublicPreciousMetalAllowTransactionConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicPreciousMetalAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicpreciousmetalallowtransactionconfig/edit/id=:id",
    name: "EditRepublicPreciousMetalAllowTransactionConfig",
    component: () => import("@/views/info/republicpreciousmetalallowtransactionconfig/edit.vue"),
    meta: {
      pageTitle: "RepublicPreciousMetalAllowTransactionConfig",
      navActiveLink: "republicpreciousmetalallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicPreciousMetalAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicpreciousmetalallowtransactionconfig/view/id=:id",
    name: "ViewRepublicPreciousMetalAllowTransactionConfig",
    component: () => import("@/views/info/republicpreciousmetalallowtransactionconfig/view.vue"),
    meta: {
      pageTitle: "RepublicPreciousMetalAllowTransactionConfig",
      navActiveLink: "republicpreciousmetalallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicPreciousMetalAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetaldevice",
    name: "preciousmetaldevice",
    component: () => import("@/views/info/preciousmetaldevice/index.vue"),
    meta: {
      pageTitle: "PreciousMetalDevice",
      navActiveLink: "preciousmetaldevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalDevice",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/preciousmetaldevice/edit/id=:id",
    name: "EditPreciousMetalDevice",
    component: () => import("@/views/info/preciousmetaldevice/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalDevice",
      navActiveLink: "preciousmetaldevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalDevice",
          active: true,
        },
      ],
    },
  },
]
